import {
  mapViewStylesRecipe
} from "./chunk-LCFOG6UH.jsx";
import {
  ANALYTICS_EVENTS,
  ANALYTICS_EVENTS2,
  ANALYTICS_PROPERTIES,
  ANALYTICS_PROPERTIES2,
  ICONS,
  ItineraryMap,
  NumberedMarkerIcon
} from "./chunk-L2YKUH66.jsx";
import {
  useOnScreen
} from "./chunk-6KGEKMGP.jsx";
import {
  Image
} from "./chunk-UVV746MP.jsx";
import {
  Conditional
} from "./chunk-AAE3RIHT.jsx";
import {
  __name
} from "./chunk-DVUTYNGK.jsx";

// src/components/NewVerticals/RouteMap/RouteMap.tsx
import { useEffect, useRef, useState } from "react";

// src/components/NewVerticals/RouteMap/components/Overlay/styles.ts
import { css } from "@headout/pixie/css";
var overlayContainer = css({
  zIndex: "999",
  position: "absolute",
  top: "0",
  height: "100%",
  width: "100%",
  backgroundColor: " rgba(0, 0, 0, 0.5)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  opacity: 0,
  transition: "opacity 0.3s",
  color: "core.primary.white",
  textStyle: "para.large",
  _hover: {
    opacity: " 1"
  }
});

// src/components/NewVerticals/RouteMap/components/Overlay/Overlay.tsx
var Overlay = /* @__PURE__ */ __name(({
  interactionEnabler,
  strings
}) => {
  const handleInteraction = /* @__PURE__ */ __name((e) => {
    e.preventDefault();
    e.stopPropagation();
    interactionEnabler();
  }, "handleInteraction");
  return <div
    className={overlayContainer}
    onClick={(e) => handleInteraction(e)}
    onTouchStart={(e) => handleInteraction(e)}
  >
			{strings.CRUISES.MAP_OVERLAY}
		</div>;
}, "Overlay");

// src/components/NewVerticals/RouteMap/styles.ts
import { sva } from "@headout/pixie/css";
var routeMapRecipe = sva({
  slots: ["wrapper", "container"],
  base: {
    wrapper: {
      position: "relative",
      height: "[466px]",
      "@media (max-width: 768px)": { height: "[329px]" }
    },
    container: {
      height: "100%",
      width: "100%",
      borderRadius: "radius.12",
      border: "none",
      overflow: "hidden",
      boxSizing: "border-box",
      zIndex: 1,
      marginTop: "space.24",
      position: "relative",
      "@media (max-width: 768px)": {
        margin: "-8px 0 0"
      }
    }
  },
  variants: {
    position: {
      top: {
        wrapper: {
          "@media (max-width: 768px)": {
            borderBottom: "none !important"
          }
        },
        container: {
          "@media (max-width: 768px)": {
            margin: "0"
          }
        }
      },
      middle: {}
    },
    isTimelineModal: {
      true: {
        container: {
          margin: "[token(spacing.space.24) 0 token(spacing.space.48)]"
        }
      }
    },
    isSightsCoveredSection: {
      true: {
        wrapper: {
          height: "[445.60px]",
          "@media (max-width: 768px)": {
            height: "[300px]"
          }
        },
        container: {
          marginTop: "0 !important"
        }
      }
    }
  },
  defaultVariants: {
    isTimelineModal: false,
    position: "middle",
    isSightsCoveredSection: false
  }
});

// src/components/NewVerticals/RouteMap/RouteMap.tsx
var RouteMap = /* @__PURE__ */ __name((props) => {
  var _a, _b;
  const {
    itinerary,
    sectionName = "",
    showRoutesTimeline = false,
    showLegend = false,
    isOnTop = false,
    showOverlay = false,
    isSightsCoveredLayout = true,
    isSightsCoveredSection = false,
    trackEvent,
    strings
  } = props;
  const [isEnabled, setIsEnabled] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen({
    ref,
    options: {
      threshold: 0.3
    }
  });
  const {
    map: routeMapData,
    details: { routeName = "" }
  } = itinerary || {};
  useEffect(() => {
    if (!isVisible) {
      setIsEnabled(false);
    }
    if (isVisible) {
      trackEvent == null ? void 0 : trackEvent({
        eventName: ANALYTICS_EVENTS.ITINERARY.MAP_VIEWED,
        [ANALYTICS_PROPERTIES.SECTION]: sectionName,
        [ANALYTICS_PROPERTIES.ITINERARY_NAME]: routeName
      });
    }
  }, [isVisible]);
  const handleInteraction = /* @__PURE__ */ __name(() => {
    setIsEnabled(true);
  }, "handleInteraction");
  const handleClickEvent = /* @__PURE__ */ __name(({
    type,
    stopName,
    stopNumber
  }) => {
    trackEvent == null ? void 0 : trackEvent({
      eventName: ANALYTICS_EVENTS.ITINERARY.MAP_VIEWED,
      [ANALYTICS_PROPERTIES.SECTION]: sectionName,
      [ANALYTICS_PROPERTIES.ITINERARY_NAME]: routeName,
      [ANALYTICS_PROPERTIES2.CLICK_TYPE]: type,
      [ANALYTICS_PROPERTIES.STOP_NAME]: stopName,
      [ANALYTICS_PROPERTIES.STOP_NUMBER]: stopNumber
    });
  }, "handleClickEvent");
  const handleZoomEvent = /* @__PURE__ */ __name(({ zoomType }) => {
    trackEvent == null ? void 0 : trackEvent({
      eventName: ANALYTICS_EVENTS2.MAP_ZOOMED,
      [ANALYTICS_PROPERTIES.SECTION]: sectionName,
      [ANALYTICS_PROPERTIES.ITINERARY_NAME]: routeName,
      [ANALYTICS_PROPERTIES2.ZOOM_TYPE]: zoomType
    });
  }, "handleZoomEvent");
  const legendItems = [
    {
      label: strings.CRUISES.BOARDING_POINTS,
      markerIcon: <div
        className={mapViewStylesRecipe().numberedMarkerIconContainer}
      >
					<NumberedMarkerIcon
        stopNumber={1}
        title={strings.CRUISES.BOARDING_POINTS}
      />
				</div>
    },
    {
      label: strings.CRUISES.LANDMARKS,
      markerIcon: <Image
        url={ICONS.PASS_BY}
        alt={strings.CRUISES.LANDMARKS}
        height={24}
        width={24}
      />
    }
  ];
  const mapStyles = routeMapRecipe({
    isTimelineModal: showRoutesTimeline,
    position: isOnTop ? "top" : "middle",
    isSightsCoveredSection
  });
  if (!((_a = itinerary == null ? void 0 : itinerary.sections) == null ? void 0 : _a.length))
    return <div className={mapStyles.container} />;
  return <div className={mapStyles.wrapper} ref={ref}>
			<div
    className={mapStyles.container}
    key={(_b = routeMapData == null ? void 0 : routeMapData.itineraryRoute) == null ? void 0 : _b.polyline}
  >
				<ItineraryMap
    itinerary={itinerary}
    onClickTrackEvent={handleClickEvent}
    onZoomTrackEvent={handleZoomEvent}
    showStartAsStop={(itinerary == null ? void 0 : itinerary.type) === "CRUISE" /* Cruise */ || isSightsCoveredLayout}
    enableFreeTouchPropagation
    {...showLegend && { legends: legendItems }}
  />
				<Conditional if={showOverlay && !isEnabled}>
					<Overlay
    interactionEnabler={handleInteraction}
    strings={strings}
    trackEvent={trackEvent}
  />
				</Conditional>
			</div>
		</div>;
}, "RouteMap");

export {
  RouteMap
};
